import React from "react";

import ACIconWrapper, { ACIconProps } from "./ACIconWrapper";

export default function EyeIcon(props: ACIconProps) {
  return <ACIconWrapper component={IconSvg} {...props} />;
}

const IconSvg = () => {
  return (
    <svg height="1em" viewBox="0 0 24 24" fill="none">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9ZM10.5 12C10.5 11.1716 11.1716 10.5 12 10.5C12.8284 10.5 13.5 11.1716 13.5 12C13.5 12.8284 12.8284 13.5 12 13.5C11.1716 13.5 10.5 12.8284 10.5 12Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12 5C8.97359 5 6.95822 6.45799 5.72187 8.03777C5.10865 8.82132 4.68428 9.63636 4.41184 10.326C4.14929 10.9906 4 11.6099 4 12C4 12.3901 4.14929 13.0094 4.41184 13.674C4.68428 14.3636 5.10865 15.1787 5.72187 15.9622C6.95822 17.542 8.97359 19 12 19C15.0264 19 17.0418 17.542 18.2781 15.9622C18.8913 15.1787 19.3157 14.3636 19.5882 13.674C19.8507 13.0094 20 12.3901 20 12C20 11.6099 19.8507 10.9906 19.5882 10.326C19.3157 9.63636 18.8913 8.82132 18.2781 8.03777C17.0418 6.45799 15.0264 5 12 5ZM5.5 12C5.5 11.8901 5.56946 11.4782 5.80691 10.8771C6.03447 10.3011 6.39135 9.61618 6.90313 8.96223C7.91678 7.66701 9.52641 6.5 12 6.5C14.4736 6.5 16.0832 7.66701 17.0969 8.96223C17.6087 9.61618 17.9655 10.3011 18.1931 10.8771C18.4305 11.4782 18.5 11.8901 18.5 12C18.5 12.1099 18.4305 12.5218 18.1931 13.1229C17.9655 13.6989 17.6087 14.3838 17.0969 15.0378C16.0832 16.333 14.4736 17.5 12 17.5C9.52641 17.5 7.91678 16.333 6.90313 15.0378C6.39135 14.3838 6.03447 13.6989 5.80691 13.1229C5.56946 12.5218 5.5 12.1099 5.5 12Z"
        fill="currentColor"
      />
    </svg>
  );
};
